import React from "react";
import { ArrowUpRight, Heart, Trophy, Utensils } from "lucide-react";
import { ABOUT, BOOKING_URL } from "../../mock/mock";
import { resolveImg } from "../adminApi";
import { useSettings } from "../useSiteData";
import D2Banner from "../D2Banner";
import { Reveal, SplitWords } from "../motionHelpers";

const ICONS = [Heart, Trophy, Utensils];

export default function AboutPage() {
  const settings = useSettings();
  const a = settings?.about || {};
  const data = {
    eyebrow: a.eyebrow || ABOUT.eyebrow,
    title: a.title || ABOUT.title,
    hero: resolveImg(a.hero || ABOUT.hero),
    intro: a.intro || ABOUT.intro,
    body: a.body || ABOUT.body,
    rt: {
      title: a.rt_title || ABOUT.rt.title,
      tagline: a.rt_tagline || ABOUT.rt.tagline,
      body: a.rt_body || ABOUT.rt.body,
      body2: a.rt_body2 || ABOUT.rt.body2,
      services: a.rt_services?.length ? a.rt_services : ABOUT.rt.services,
      image: resolveImg(a.rt_image || ABOUT.rt.image),
    },
  };
  return (
    <div>
      <D2Banner eyebrow={data.eyebrow} title={data.title} subtitle={data.intro} image={data.hero} crumbs={[{ label: "About Us" }]} />

      <section className="d2-bg py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-start">
          <Reveal>
            <h2 className="font-display uppercase text-white text-4xl md:text-6xl leading-[0.92]">
              <SplitWords text="More than" className="block" />
              <SplitWords text="a place to play" className="block text-sc-lime" delay={0.12} />
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-white/70 text-lg font-grotesk">{data.body}</p>
          </Reveal>
        </div>

        <div className="max-w-[1400px] mx-auto px-5 lg:px-8 grid sm:grid-cols-3 gap-5 mt-14">
          {ABOUT.values.map((v, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={v.title} delay={i * 0.09}>
                <div className="d2-card bg-[#0b241a] border border-white/10 rounded-2xl p-8 h-full">
                  <div className="w-12 h-12 rounded-full bg-sc-lime flex items-center justify-center"><Icon className="w-6 h-6 text-[#06170f]" /></div>
                  <h3 className="font-display uppercase text-2xl text-white mt-5">{v.title}</h3>
                  <p className="text-white/60 mt-2 font-grotesk">{v.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section id="rt-sports" className="bg-sc-cream py-24 md:py-32 relative overflow-hidden">
        <div className="absolute top-6 right-0 select-none pointer-events-none">
          <span className="font-display uppercase text-outline text-[18vw] leading-none">RT SPORTS</span>
        </div>
        <div className="max-w-[1400px] mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center relative">
          <Reveal>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img src={data.rt.image} alt="RT Sports" className="w-full h-[420px] object-cover" />
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <span className="font-grotesk uppercase tracking-[0.3em] text-sc-orange text-sm">Owner & Operator</span>
            <h2 className="font-display uppercase text-sc-green text-4xl md:text-6xl leading-[0.92] mt-3">{data.rt.title}</h2>
            <p className="font-mono2 text-sm text-sc-green/70 mt-2">{data.rt.tagline}</p>
            <p className="text-gray-600 text-lg mt-6 font-grotesk">{data.rt.body}</p>
            <p className="text-gray-600 text-lg mt-4 font-grotesk">{data.rt.body2}</p>

            <div className="mt-6">
              <p className="font-grotesk uppercase tracking-widest text-xs text-sc-green/60 mb-3">How RT Sports can help</p>
              <div className="flex flex-wrap gap-2">
                {data.rt.services.map((s) => (
                  <span key={s} className="font-grotesk text-sm text-sc-green bg-white border border-sc-green/15 rounded-full px-4 py-1.5">{s}</span>
                ))}
              </div>
            </div>

            <a href={BOOKING_URL} className="btn-green inline-flex items-center gap-3 px-8 py-4 mt-8 text-sm font-bold">Book a Court <ArrowUpRight className="w-4 h-4" /></a>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
